import style from './TableItem.module.css'
import {ReactComponent as Correct} from '../../Assets/icons/Correct.svg'
import { useNavigate } from 'react-router-dom'
import { useMemo, useState } from 'react'
import {ReactComponent as Arrow} from '../../Assets/icons/arrow_white.svg'

const getColor = (correction) => {
    if(correction > 0){
        return 'green'
        return '#33CC33'
    } else if (correction < 0){
        return 'red'
        return '#F0142F'
    } else {
        return ''
        return '#ff931e'
    }
}

export function MapListItem({data}) {
    const [open, setOpen] = useState(false)
    const stoks = useMemo(() => data.stocks.reduce((acc, item) => acc + item.stock, 0))
    const color = getColor(data.price_correction)

    return <div className={style.mapListITem} >
        <div className={style.topMapListItem}>
            <div className={style.title}>
                <h2 className={style.maker} onClick={() => window.open(data.cable_url, '_blank')}>{data.vendor_name}</h2>
                <p className={style.market}>({data.marketplace_name})</p>
            </div>
            <div className={style.correction}>
                <Correct fill={color === 'green' ? '#33CC33' :color === 'red' ? '#F0142F' : '#ff931e' } stroke={color === 'green' ? '#33CC33' :color === 'red' ? '#F0142F' : '#ff931e' } /> 
                <p className={`${style.correction__text} ${style[getColor(data.price_correction)]}`}>{data.price_correction > 0 && '+'}{data.price_correction}</p>
            </div>
            <p className={style.price}>{data.price}</p>
        </div>
        <div className={style.bottomMapListItem}>
            <div className={style.stoksAccord}>
                <div className={style.stoksAccord__header} onClick={() => data.stocks.length > 0 ? setOpen(!open) : false}>
                    <div className={style.whiteArrow} style={{transform: open ? `rotate(180deg)` : `rotate(0deg)`}}><Arrow /></div>
                    Остатки 
                </div>
                <div className={`${style.stockList} ${open && style.stockList__open}`}>
                    {data.stocks.map((item, index) => {
                        return <div className={style.stockListItem}>
                            <p title={item.store_address} className={style.address}>{item.store_address}</p>
                            <p>{item.stock} м</p>
                        </div>
                    })}
                </div>
            </div>
            <div className={style.stoksIndicator}>
                {stoks > 0 
                    ? <div className={style.indicatorBlock} style={{backgroundColor: '#33CC33'}}></div>
                    : <div className={style.indicatorBlock} style={{backgroundColor: '#EE3B3B'}}></div>
                }
                <div className={style.stoksCount}>{stoks} м</div>
            </div>
        </div>
    </div>

    
}

